import * as React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

export const menuGridSx = {
  display: "grid",
  gap: 2,
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(3, minmax(0, 1fr))",
  },
};

// List-style card skeleton matching ItemCard (text left, thumbnail right).
export function ItemCardSkeleton() {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        p: 1.5,
        minHeight: 136,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
      }}
    >
      <Stack flex={1} spacing={0.5}>
        <Skeleton variant="text" width="70%" height={28} />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width={56} height={28} />
      </Stack>
      <Skeleton variant="rounded" width={96} height={96} sx={{ flexShrink: 0 }} />
    </Stack>
  );
}

export default function MenuSkelton({ showMenu = true }) {
  const { t } = useTranslation();
  return (
    <Stack
      spacing={{ xs: 0, md: 2 }}
      direction="row"
      p={{ xs: 2, md: 3 }}
      aria-busy="true"
      aria-label={t("menuSkelton.loadingMenu")}
    >
      {showMenu && (
        <Stack sx={{ display: { xs: "none", md: "flex" } }} gap={1.5} width="20%">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <Skeleton key={i} variant="rounded" height={44} />
          ))}
        </Stack>
      )}
      <Box sx={menuGridSx} flex={1} minWidth={0}>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <ItemCardSkeleton key={i} />
        ))}
      </Box>
    </Stack>
  );
}
